export const SOECohesionConfig = {
  fuse: {
    endpoint: 'https://www.saveonenergy.com/fuse',
  },
  monarch: {
    autoRequest: {
      enabled: true,
      suppressPlacements: true,
      timeout: 15000,
    },
    sourceId: '40ebe324-af0c-4972-a37e-685b56478d78',
    token: 'b9160209-901b-4655-bd1b-3c1066cfa34b',
  },
  tagular: {
    apiKey: '4b27d1c6-e19e-4cc0-add3-a44b9b4a4023',
    writeKey: 'wk_1NT29fZnmCI1A7GIPi5SDsQYJk7',
    sourceKey: 'src_1NT29duG0CBw0VyASD4m0mdCOxd',
    // beamHook: function (event) {
    //   window.dataLayer = window.dataLayer || []
    //   window.dataLayer.push({ event: event['@type'], tagularPayload: event })
    // },
    cookieDomain: 'saveonenergy.com',
    domainWhitelist: ['electricrates.saveonenergy.com'],
    apiHost: 'https://www.saveonenergy.com/tagular/v2/t',
    apiVersion: 'v2/t',
    iframeAllowList: ['https://offers.qa.bankrate.com', 'https://offers.bankrate.com'],
  },
}
